export const LOGIN_DATA = "LOGIN_DATA"
export const UPDATE_FULL_SCREEN_LOADER = "UPDATE_FULL_SCREEN_LOADER";
export const UPDATE_ONBOARDING_STATE = "UPDATE_ONBOARDING_STATE";